<!-- cv简历信息表-家庭信息-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <h4 class='pad-top'>父亲信息</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>姓名：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>手机号：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.phone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Email：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.email}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>毕业时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>出生日期：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.brithday}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>出生地点：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.brithplace}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>居住地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>是否健在：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.vitalStatus && new Map(isVitalCnMap).get(familyDetailCn.fatherInfo.vitalStatus)}}</span>
          </li>
          <li v-if='familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.vitalStatus === "0"'>
            <span class='cv-detail-name'>去世时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.deathTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>最高学历：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.highestDegree && new Map(highestDegreeCnMap).get(familyDetailCn.fatherInfo.highestDegree)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>工作单位：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.company}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>职务：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.job}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>在此单位年限：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.workLength}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>年收入：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.annualSalary}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>大专/中专/高中/毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.highSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.highSchoolTime && familyDetailCn.fatherInfo.highSchoolTime[0] && familyDetailCn.fatherInfo.highSchoolTime[1] && `${familyDetailCn.fatherInfo.highSchoolTime[0]} 至 ${familyDetailCn.fatherInfo.highSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>本科毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.ugdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.ugdSchoolTime && familyDetailCn.fatherInfo.ugdSchoolTime[0] && familyDetailCn.fatherInfo.ugdSchoolTime[1] && `${familyDetailCn.fatherInfo.ugdSchoolTime[0]} 至 ${familyDetailCn.fatherInfo.ugdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>学校地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.ugdSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>硕士毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.masterSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.masterSchoolTime && familyDetailCn.fatherInfo.masterSchoolTime[0] && familyDetailCn.fatherInfo.masterSchoolTime[1] && `${familyDetailCn.fatherInfo.masterSchoolTime[0]} 至 ${familyDetailCn.fatherInfo.masterSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>学校地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.masterSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>博士毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.phdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.phdSchoolTime && familyDetailCn.fatherInfo.phdSchoolTime[0] && familyDetailCn.fatherInfo.phdSchoolTime[1] && `${familyDetailCn.fatherInfo.phdSchoolTime[0]} 至 ${familyDetailCn.fatherInfo.phdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>学校地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.fatherInfo && familyDetailCn.fatherInfo.phdSchoolAddress}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>母亲信息</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>姓名：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>手机号：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.phone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Email：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.email}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>毕业时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>出生日期：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.brithday}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>出生地点：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.brithplace}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>居住地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>是否健在：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.vitalStatus && new Map(isVitalCnMap).get(familyDetailCn.motherInfo.vitalStatus)}}</span>
          </li>
          <li v-if='familyDetailCn.motherInfo && familyDetailCn.motherInfo.vitalStatus === "0"'>
            <span class='cv-detail-name'>去世时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.deathTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>最高学历：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.highestDegree && new Map(highestDegreeCnMap).get(familyDetailCn.motherInfo.highestDegree)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>工作单位：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.company}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>职务：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.job}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>在此单位年限：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.workLength}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>年收入：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.annualSalary}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>大专/中专/高中/毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.highSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.highSchoolTime && familyDetailCn.motherInfo.highSchoolTime[0] && familyDetailCn.motherInfo.highSchoolTime[1] && `${familyDetailCn.motherInfo.highSchoolTime[0]} 至 ${familyDetailCn.motherInfo.highSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>本科毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.ugdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.ugdSchoolTime && familyDetailCn.motherInfo.ugdSchoolTime[0] && familyDetailCn.motherInfo.ugdSchoolTime[1] && `${familyDetailCn.motherInfo.ugdSchoolTime[0]} 至 ${familyDetailCn.motherInfo.ugdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>学校地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.ugdSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>硕士毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.masterSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.masterSchoolTime && familyDetailCn.motherInfo.masterSchoolTime[0] && familyDetailCn.motherInfo.masterSchoolTime[1] && `${familyDetailCn.motherInfo.masterSchoolTime[0]} 至 ${familyDetailCn.motherInfo.masterSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>学校地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.masterSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>博士毕业院校：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.phdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>就读时间：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.phdSchoolTime && familyDetailCn.motherInfo.phdSchoolTime[0] && familyDetailCn.motherInfo.phdSchoolTime[1] && `${familyDetailCn.motherInfo.phdSchoolTime[0]} 至 ${familyDetailCn.motherInfo.phdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>学校地址：</span>
            <span class='cv-detail-val'>{{familyDetailCn.motherInfo && familyDetailCn.motherInfo.phdSchoolAddress}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>其他信息</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>父母婚姻状况：</span>
            <span class='cv-detail-val'>{{familyDetailCn.maritalStatus && new Map(maritalCnMap).get(familyDetailCn.maritalStatus)}}</span>
          </li>
          <li v-if='formValidateCn.maritalStatus === "DIVORCED"'>
            <span class='cv-detail-name'>离婚日期：</span>
            <span class='cv-detail-val'>{{familyDetailCn.divorceDate}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>你的法定监护人：</span>
            <span class='cv-detail-val'>{{familyDetailCn.guardian && new Map(guardianCnMap).get(familyDetailCn.guardian)}}</span>
          </li>
          <li v-if='formValidateCn.guardian === "OTHER"'>
            <span class='cv-detail-name'>其他法定监护人：</span>
            <span class='cv-detail-val'>{{familyDetailCn.otherGuardian}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>是否有兄弟姐妹：</span>
            <span class='cv-detail-val'>{{familyDetailCn.siblingCount && new Map(brotherCnMap).get(familyDetailCn.siblingCount)}}</span>
          </li>
          <li class='sub-list'
              v-if='familyDetailCn.siblings && familyDetailCn.siblings.length > 0'>
            <div v-for='(item, index) in familyDetailCn.siblings'
                 :key='index'>
              <div class='sub-item'>
                <span class='cv-detail-name'>与申请人关系：</span>
                <span class='cv-detail-val'>{{item.relationship}}</span>
              </div>
              <div class='sub-item'>
                <span class='cv-detail-name'>出生日期：</span>
                <span class='cv-detail-val'>{{item.brithday}}</span>
              </div>
              <div class='sub-item'>
                <span class='cv-detail-name'>学历：</span>
                <span class='cv-detail-val'>{{item.degree}}</span>
              </div>
              <div class='sub-item'>
                <span class='cv-detail-name'>院校名称：</span>
                <span class='cv-detail-val'>{{item.school}}</span>
              </div>
            </div>
          </li>
          <li>
            <span class='cv-detail-name'>其他信息：</span>
            <span class='cv-detail-val'>{{familyDetailCn.otherInfo}}</span>
          </li>
        </ul>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <h4 class='pad-top'>Father</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>Name：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Cell Phone Number：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.phone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Email：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.email}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Date of Graduation：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Date of Birth：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.brithday}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Place of Birth：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.brithplace}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Vital Status：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.vitalStatus && new Map(isVitalEnMap).get(familyDetailEn.fatherInfo.vitalStatus)}}</span>
          </li>
          <li v-if='familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.vitalStatus === "0"'>
            <span class='cv-detail-name'>Time of Death：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.deathTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Highest Degree Attained：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.highestDegree && new Map(highestDegreeEnMap).get(familyDetailEn.fatherInfo.highestDegree)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Company Name：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.company}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Job Title：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.job}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of work at the company：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.workLength}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Father’s Annual Salary：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.annualSalary}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of Junior College/ Technical Secondary School/ High School：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.highSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.highSchoolTime && familyDetailEn.fatherInfo.highSchoolTime[0] && familyDetailEn.fatherInfo.highSchoolTime[1] && `${familyDetailEn.fatherInfo.highSchoolTime[0]} to ${familyDetailEn.fatherInfo.highSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of College/University：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.ugdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.ugdSchoolTime && familyDetailEn.fatherInfo.ugdSchoolTime[0] && familyDetailEn.fatherInfo.ugdSchoolTime[1] && `${familyDetailEn.fatherInfo.ugdSchoolTime[0]} to ${familyDetailEn.fatherInfo.ugdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>School Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.ugdSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of School Conferring Master's Degree：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.masterSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.masterSchoolTime && familyDetailEn.fatherInfo.masterSchoolTime[0] && familyDetailEn.fatherInfo.masterSchoolTime[1] && `${familyDetailEn.fatherInfo.masterSchoolTime[0]} to ${familyDetailEn.fatherInfo.masterSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>School Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.masterSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of School Conferring Doctorate：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.phdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.phdSchoolTime && familyDetailEn.fatherInfo.phdSchoolTime[0] && familyDetailEn.fatherInfo.phdSchoolTime[1] && `${familyDetailEn.fatherInfo.phdSchoolTime[0]} to ${familyDetailEn.fatherInfo.phdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>School Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.fatherInfo && familyDetailEn.fatherInfo.phdSchoolAddress}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>Mother</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>Name：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.name}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Cell Phone Number：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.phone}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Email：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.email}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Date of Graduation：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.graduationTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Date of Birth：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.brithday}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Place of Birth：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.brithplace}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.address}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Vital Status：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.vitalStatus && new Map(isVitalEnMap).get(familyDetailEn.motherInfo.vitalStatus)}}</span>
          </li>
          <li v-if='familyDetailEn.motherInfo && familyDetailEn.motherInfo.vitalStatus === "0"'>
            <span class='cv-detail-name'>Time of Death：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.deathTime}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Highest Degree Attained：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.highestDegree && new Map(highestDegreeEnMap).get(familyDetailEn.motherInfo.highestDegree)}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Company Name：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.company}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Job Title：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.job}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of work at the company：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.workLength}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Mother’s Annual Salary：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.annualSalary}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of Junior College/ Technical Secondary School/ High School：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.highSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.highSchoolTime && familyDetailEn.motherInfo.highSchoolTime[0] && familyDetailEn.motherInfo.highSchoolTime[1] && `${familyDetailEn.motherInfo.highSchoolTime[0]} to ${familyDetailEn.motherInfo.highSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of College/University：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.ugdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.ugdSchoolTime && familyDetailEn.motherInfo.ugdSchoolTime[0] && familyDetailEn.motherInfo.ugdSchoolTime[1] && `${familyDetailEn.motherInfo.ugdSchoolTime[0]} to ${familyDetailEn.motherInfo.ugdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>School Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.ugdSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of School Conferring Master's Degree：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.masterSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.masterSchoolTime && familyDetailEn.motherInfo.masterSchoolTime[0] && familyDetailEn.motherInfo.masterSchoolTime[1] && `${familyDetailEn.motherInfo.masterSchoolTime[0]} to ${familyDetailEn.motherInfo.masterSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>School Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.masterSchoolAddress}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Name of School Conferring Doctorate：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.phdSchool}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Length of Study：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.phdSchoolTime && familyDetailEn.motherInfo.phdSchoolTime[0] && familyDetailEn.motherInfo.phdSchoolTime[1] && `${familyDetailEn.motherInfo.phdSchoolTime[0]} to ${familyDetailEn.motherInfo.phdSchoolTime[1]}`}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>School Address：</span>
            <span class='cv-detail-val'>{{familyDetailEn.motherInfo && familyDetailEn.motherInfo.phdSchoolAddress}}</span>
          </li>
        </ul>
        <h4 class='pad-top'>Additional Information</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>Parents' Marital Status：</span>
            <span class='cv-detail-val'>{{familyDetailEn.maritalStatus && new Map(maritalEnMap).get(familyDetailEn.maritalStatus)}}</span>
          </li>
          <li v-if='formValidateEn.maritalStatus === "DIVORCED"'>
            <span class='cv-detail-name'>Date of Divorce：</span>
            <span class='cv-detail-val'>{{familyDetailEn.divorceDate}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Applicant's Legal Guardian：</span>
            <span class='cv-detail-val'>{{familyDetailEn.guardian && new Map(guardianEnMap).get(familyDetailEn.guardian)}}</span>
          </li>
          <li v-if='formValidateEn.guardian === "OTHER"'>
            <span class='cv-detail-name'>Other Legal Guardian：</span>
            <span class='cv-detail-val'>{{familyDetailEn.otherGuardian}}</span>
          </li>
          <li>
            <span class='cv-detail-name'>Siblings：</span>
            <span class='cv-detail-val'>{{familyDetailEn.siblingCount && new Map(brotherEnMap).get(familyDetailEn.siblingCount)}}</span>
          </li>
          <li class='sub-list'
              v-if='familyDetailEn.siblings && familyDetailEn.siblings.length > 0'>
            <div v-for='(item, index) in familyDetailEn.siblings'
                 :key='index'>
              <div class='sub-item'>
                <span class='cv-detail-name'>Relationship with applicant：</span>
                <span class='cv-detail-val'>{{item.relationship}}</span>
              </div>
              <div class='sub-item'>
                <span class='cv-detail-name'>Date of birth：</span>
                <span class='cv-detail-val'>{{item.brithday}}</span>
              </div>
              <div class='sub-item'>
                <span class='cv-detail-name'>Level of Education：</span>
                <span class='cv-detail-val'>{{item.degree}}</span>
              </div>
              <div class='sub-item'>
                <span class='cv-detail-name'>Name of School：</span>
                <span class='cv-detail-val'>{{item.school}}</span>
              </div>
            </div>
          </li>
          <li>
            <span class='cv-detail-name'>Additional Information：</span>
            <span class='cv-detail-val'>{{familyDetailEn.otherInfo}}</span>
          </li>
        </ul>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              :label-width="300">

          <div class="base-form-item">
            <h4 class='pad-top'>父亲信息</h4>
            <FormItem label="姓名："
                      prop="fatherInfo.name">
              <Input v-model="formValidateCn.fatherInfo.name"
                     placeholder="请输入姓名"
                     clearable></Input>
            </FormItem>
            <FormItem label="手机号："
                      prop="fatherInfo.phone">
              <Input v-model="formValidateCn.fatherInfo.phone"
                     placeholder="请输入手机号"
                     clearable></Input>
            </FormItem>
            <FormItem label="Email："
                      prop="fatherInfo.email">
              <Input v-model="formValidateCn.fatherInfo.email"
                     placeholder="请输入邮箱"
                     clearable></Input>
            </FormItem>
            <FormItem label="毕业时间："
                      prop="fatherInfo.graduationTime">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.fatherInfo.graduationTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="出生日期："
                      prop="fatherInfo.brithday">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.fatherInfo.brithday"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="出生地点："
                      prop="fatherInfo.brithplace">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.fatherInfo.brithplace"
                     placeholder="请输入出生地点，国家，省份，城市，地址"></Input>
            </FormItem>
            <FormItem label="居住地址："
                      prop="fatherInfo.address">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.fatherInfo.address"
                     placeholder="请输入居住地址"></Input>
            </FormItem>
            <FormItem label="是否健在："
                      prop="fatherInfo.vitalStatus">
              <Select v-model="formValidateCn.fatherInfo.vitalStatus"
                      placeholder="请选择"
                      @on-change='cnFatherInfoVitalStatus'
                      clearable>
                <Option v-for="(item, index) in isVitalCnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div v-show='formValidateCn.fatherInfo.vitalStatus === "0"'>
              <FormItem label="去世时间："
                        prop="fatherInfo.deathTime">
                <date-picker-wrapper type="date"
                                     :editable='false'
                                     placeholder="请选择"
                                     v-model="formValidateCn.fatherInfo.deathTime"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
            </div>
            <FormItem label="最高学历："
                      prop="fatherInfo.highestDegree">
              <Select v-model="formValidateCn.fatherInfo.highestDegree"
                      placeholder="请选择"
                      clearable>
                <Option v-for="item in highestDegreeCnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="工作单位："
                      prop="fatherInfo.company">
              <Input v-model="formValidateCn.fatherInfo.company"
                     placeholder="请输入工作单位"
                     clearable></Input>
            </FormItem>
            <FormItem label="职务："
                      prop="fatherInfo.job">
              <Input v-model="formValidateCn.fatherInfo.job"
                     placeholder="请输入职务"
                     clearable></Input>
            </FormItem>
            <FormItem label="在此单位年限："
                      prop="fatherInfo.workLength">
              <Input v-model="formValidateCn.fatherInfo.workLength"
                     placeholder="请输入在此单位年限"
                     clearable></Input>
            </FormItem>
            <FormItem label="年收入："
                      prop="fatherInfo.annualSalary">
              <Input v-model="formValidateCn.fatherInfo.annualSalary"
                     placeholder="申请加州系列大学需填写，单位万元"
                     clearable></Input>
            </FormItem>
            <FormItem label="大专/中专/高中毕业院校名称："
                      prop="fatherInfo.highSchool">
              <Input v-model="formValidateCn.fatherInfo.highSchool"
                     placeholder="请输入大专/中专/高中毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="fatherInfo.highSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.fatherInfo.highSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="本科毕业院校名称："
                      prop="fatherInfo.ugdSchool">
              <Input v-model="formValidateCn.fatherInfo.ugdSchool"
                     placeholder="请输入本科毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="fatherInfo.ugdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.fatherInfo.ugdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="学校地址："
                      prop="fatherInfo.ugdSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateCn.fatherInfo.ugdSchoolAddress"
                     :rows='5'
                     placeholder="请输入学校地址"></Input>
            </FormItem>
            <FormItem label="硕士毕业院校名称："
                      prop="fatherInfo.masterSchool">
              <Input v-model="formValidateCn.fatherInfo.masterSchool"
                     placeholder="请输入硕士毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="fatherInfo.masterSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.fatherInfo.masterSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="学校地址："
                      prop="fatherInfo.masterSchoolAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.fatherInfo.masterSchoolAddress"
                     placeholder="请输入学校地址"></Input>
            </FormItem>
            <FormItem label="博士毕业院校名称："
                      prop="fatherInfo.phdSchool">
              <Input v-model="formValidateCn.fatherInfo.phdSchool"
                     placeholder="请输入博士毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="fatherInfo.phdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.fatherInfo.phdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="学校地址："
                      prop="fatherInfo.phdSchoolAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.fatherInfo.phdSchoolAddress"
                     placeholder="请输入学校地址"></Input>
            </FormItem>
            <h4 class='pad-top'>母亲信息</h4>
            <FormItem label="姓名："
                      prop="motherInfo.name">
              <Input v-model="formValidateCn.motherInfo.name"
                     placeholder="请输入姓名"
                     clearable></Input>
            </FormItem>
            <FormItem label="手机号："
                      prop="motherInfo.phone">
              <Input v-model="formValidateCn.motherInfo.phone"
                     placeholder="请输入手机号"
                     clearable></Input>
            </FormItem>
            <FormItem label="Email："
                      prop="motherInfo.email">
              <Input v-model="formValidateCn.motherInfo.email"
                     placeholder="请输入邮箱"
                     clearable></Input>
            </FormItem>
            <FormItem label="毕业时间："
                      prop="motherInfo.graduationTime">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.motherInfo.graduationTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="出生日期："
                      prop="motherInfo.brithday">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.motherInfo.brithday"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="出生地点："
                      prop="motherInfo.brithplace">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.motherInfo.brithplace"
                     placeholder="请输入出生地点，国家，省份，城市，地址"></Input>
            </FormItem>
            <FormItem label="居住地址："
                      prop="motherInfo.address">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.motherInfo.address"
                     placeholder="请输入居住地址"
                     clearable></Input>
            </FormItem>
            <FormItem label="是否健在："
                      prop="motherInfo.vitalStatus">
              <Select v-model="formValidateCn.motherInfo.vitalStatus"
                      placeholder="请选择"
                      @on-change='cnMotherInfoVitalStatus'
                      clearable>
                <Option v-for="(item, index) in isVitalCnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div v-if='formValidateCn.motherInfo.vitalStatus === "0"'>
              <FormItem label="去世时间："
                        prop="motherInfo.deathTime">
                <date-picker-wrapper type="date"
                                     :editable='false'
                                     placeholder="请选择"
                                     v-model="formValidateCn.motherInfo.deathTime"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
            </div>
            <FormItem label="最高学历："
                      prop="motherInfo.highestDegree">
              <Select v-model="formValidateCn.motherInfo.highestDegree"
                      placeholder="请选择"
                      clearable>
                <Option v-for="item in highestDegreeCnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="工作单位名："
                      prop="motherInfo.company">
              <Input v-model="formValidateCn.motherInfo.company"
                     placeholder="请输入工作单位名"
                     clearable></Input>
            </FormItem>
            <FormItem label="职务："
                      prop="motherInfo.job">
              <Input v-model="formValidateCn.motherInfo.job"
                     placeholder="请输入职务"
                     clearable></Input>
            </FormItem>
            <FormItem label="在此单位年限："
                      prop="motherInfo.workLength">
              <Input v-model="formValidateCn.motherInfo.workLength"
                     placeholder="请输入在此单位年限"
                     clearable></Input>
            </FormItem>
            <FormItem label="年收入："
                      prop="motherInfo.annualSalary">
              <Input v-model="formValidateCn.motherInfo.annualSalary"
                     placeholder="申请加州系列大学需填写，单位万元"
                     clearable></Input>
            </FormItem>
            <FormItem label="大专/中专/高中毕业院校名称："
                      prop="motherInfo.highSchool">
              <Input v-model="formValidateCn.motherInfo.highSchool"
                     placeholder="请输入大专/中专/高中毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="motherInfo.highSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.motherInfo.highSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="本科毕业院校名称："
                      prop="motherInfo.ugdSchool">
              <Input v-model="formValidateCn.motherInfo.ugdSchool"
                     placeholder="请输入本科毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="motherInfo.ugdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.motherInfo.ugdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="学校地址："
                      prop="motherInfo.ugdSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateCn.motherInfo.ugdSchoolAddress"
                     :rows='5'
                     placeholder="请输入学校地址"></Input>
            </FormItem>
            <FormItem label="硕士毕业院校名称："
                      prop="motherInfo.masterSchool">
              <Input v-model="formValidateCn.motherInfo.masterSchool"
                     placeholder="请输入硕士毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="motherInfo.masterSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.motherInfo.masterSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="学校地址："
                      prop="motherInfo.masterSchoolAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.motherInfo.masterSchoolAddress"
                     placeholder="请输入学校地址"></Input>
            </FormItem>
            <FormItem label="博士毕业院校名称："
                      prop="motherInfo.phdSchool">
              <Input v-model="formValidateCn.motherInfo.phdSchool"
                     placeholder="请输入博士毕业院校名称"
                     clearable></Input>
            </FormItem>
            <FormItem label="就读时间："
                      prop="motherInfo.phdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="请选择"
                                   v-model="formValidateCn.motherInfo.phdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="学校地址："
                      prop="motherInfo.phdSchoolAddress">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.motherInfo.phdSchoolAddress"
                     placeholder="请输入学校地址"></Input>
            </FormItem>
            <h4 class='pad-top'>其他信息</h4>
            <FormItem label="父母婚姻状况："
                      prop="maritalStatus">
              <Select v-model="formValidateCn.maritalStatus"
                      @on-change='cnMaritalStatus'
                      placeholder="请选择"
                      clearable>
                <Option v-for="item in maritalCnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div v-if='formValidateCn.maritalStatus === "DIVORCED"'>
              <FormItem label="离婚日期："
                        prop="divorceDate">
                <date-picker-wrapper type="date"
                                     placeholder="请选择"
                                     v-model="formValidateCn.divorceDate"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
            </div>
            <FormItem label="你的法定监护人："
                      prop="guardian">
              <Select v-model="formValidateCn.guardian"
                      placeholder="请选择"
                      @on-change='cnGuardian'
                      clearable>
                <Option v-for="item in guardianCnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
              <!--<Input v-model="formValidateCn.guardian"-->
              <!--placeholder="请输入你的法定监护人"-->
              <!--clearable></Input>-->
            </FormItem>
            <div v-if='formValidateCn.guardian === "OTHER"'>
              <FormItem label="其他法定监护人："
                        prop="otherGuardian">
                <Input v-model="formValidateCn.otherGuardian"
                       placeholder="请输入其他法定监护人"
                       clearable></Input>
              </FormItem>
            </div>
            <FormItem label="是否有兄弟姐妹："
                      prop="siblingCount">
              <Select v-model="formValidateCn.siblingCount"
                      placeholder="请选择"
                      clearable>
                <Option v-for="(item, index) in brotherCnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div class="base-form-item-list"
                 v-if='formValidateCn.siblings && formValidateCn.siblings.length > 0'>
              <div class="base-form-item"
                   v-for='(item, index) in formValidateCn.siblings'
                   :key='index'>
                <FormItem label="与申请人关系："
                          :prop="`siblings.${index}.relationship`"
                          :rules="[{required: true, message: '请输入与申请人关系'}]">
                  <Input v-model="item.relationship"
                         placeholder="请输入与申请人关系"
                         clearable></Input>
                </FormItem>
                <FormItem label="出生日期："
                          :prop="`siblings.${index}.brithday`"
                          :rules="[{required: true, message: '请选择'}]">
                  <date-picker-wrapper type="date"
                                       :editable='false'
                                       placeholder="请选择"
                                       v-model="item.brithday"
                                       style="width:100%;"></date-picker-wrapper>
                </FormItem>
                <FormItem label="学历："
                          :prop="`siblings.${index}.degree`"
                          :rules="[{required: true, message: '请输入学历'}]">
                  <Input v-model="item.degree"
                         placeholder="请输入学历"
                         clearable></Input>
                </FormItem>
                <FormItem label="院校名称："
                          :prop="`siblings.${index}.school`"
                          :rules="[{required: true, message: '请输入院校名称'}]">
                  <Input v-model="item.school"
                         placeholder="请输入院校名称"
                         clearable></Input>
                </FormItem>
                <div class='oper-del'>
                  <a href='javascript: void(0)'
                     @click="delCn(item, index)">删除</a>
                </div>
              </div>
            </div>
            <div class='oper-add'>
              <a href='javascript: void(0)'
                 @click="addCn">添加</a>
            </div>
            <FormItem label="其他信息："
                      prop="otherInfo">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateCn.otherInfo"
                     placeholder="其他需要说明的情况，如多个兄弟姐妹等"></Input>
            </FormItem>

            <div class="sub-btn">
              <Button type='primary'
                      :loading='hasSaveCn'
                      @click="saveCn">保存</Button>
            </div>
          </div>
        </Form>
      </div>
      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-item">
            <h4 class='pad-top'>Father</h4>
            <FormItem label="Name："
                      prop="fatherInfo.name">
              <Input v-model="formValidateEn.fatherInfo.name"
                     placeholder="Please enter name"
                     clearable></Input>
            </FormItem>
            <FormItem label="Cell Phone Number："
                      prop="fatherInfo.phone">
              <Input v-model="formValidateEn.fatherInfo.phone"
                     placeholder="Please enter cell phone number"
                     clearable></Input>
            </FormItem>
            <FormItem label="Email："
                      prop="fatherInfo.email">
              <Input v-model="formValidateEn.fatherInfo.email"
                     placeholder="Please enter email"
                     clearable></Input>
            </FormItem>
            <FormItem label="Date of Graduation："
                      prop="fatherInfo.graduationTime">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.fatherInfo.graduationTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="Date of Birth："
                      prop="fatherInfo.brithday">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.fatherInfo.brithday"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="Place of Birth："
                      prop="fatherInfo.brithplace">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.fatherInfo.brithplace"
                     placeholder="Please specify city, province, and country"></Input>
            </FormItem>
            <FormItem label="Address："
                      prop="fatherInfo.address">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.fatherInfo.address"
                     placeholder="Please enter address"></Input>
            </FormItem>
            <FormItem label="Vital Status："
                      prop="fatherInfo.vitalStatus">
              <Select v-model="formValidateEn.fatherInfo.vitalStatus"
                      placeholder="Please select"
                      @on-change='enFatherInfoVitalStatus'
                      clearable>
                <Option v-for="(item, index) in isVitalEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div v-if='formValidateEn.fatherInfo.vitalStatus === "0"'>
              <FormItem label="Time of Death："
                        prop="fatherInfo.deathTime">
                <date-picker-wrapper type="date"
                                     :editable='false'
                                     placeholder="Please select"
                                     v-model="formValidateEn.fatherInfo.deathTime"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
            </div>
            <FormItem label="Highest Degree Attained："
                      prop="fatherInfo.highestDegree">
              <Select v-model="formValidateEn.fatherInfo.highestDegree"
                      placeholder="Please select"
                      clearable>
                <Option v-for="item in highestDegreeEnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Company Name in English："
                      prop="fatherInfo.company">
              <Input v-model="formValidateEn.fatherInfo.company"
                     placeholder="Please enter company name in English"
                     clearable></Input>
            </FormItem>
            <FormItem label="Job Title："
                      prop="fatherInfo.job">
              <Input v-model="formValidateEn.fatherInfo.job"
                     placeholder="Please enter job title"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of work at the company："
                      prop="fatherInfo.workLength">
              <Input v-model="formValidateEn.fatherInfo.workLength"
                     placeholder="Please enter length of work at the company"
                     clearable></Input>
            </FormItem>
            <FormItem label="Father’s Annual Salary："
                      prop="fatherInfo.annualSalary">
              <Input v-model="formValidateEn.fatherInfo.annualSalary"
                     placeholder="Required by schools in California, unit - 10,000 yuan"
                     clearable></Input>
            </FormItem>
            <FormItem label="English Name of Junior College/ Technical Secondary School/ High School："
                      prop="fatherInfo.highSchool">
              <Input v-model="formValidateEn.fatherInfo.highSchool"
                     placeholder="Please enter English name of junior college/ technical secondary School/ high school"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="fatherInfo.highSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.fatherInfo.highSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="English Name of College/University："
                      prop="fatherInfo.ugdSchool">
              <Input v-model="formValidateEn.fatherInfo.ugdSchool"
                     placeholder="Please enter English name of college/university"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="fatherInfo.ugdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.fatherInfo.ugdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="School Address："
                      prop="fatherInfo.ugdSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateEn.fatherInfo.ugdSchoolAddress"
                     :rows='5'
                     placeholder="Please enter school address"></Input>
            </FormItem>
            <FormItem label="English Name of School Conferring Master's Degree："
                      prop="fatherInfo.masterSchool">
              <Input v-model="formValidateEn.fatherInfo.masterSchool"
                     placeholder="Please enter English name of school conferring master's degree"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="fatherInfo.masterSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.fatherInfo.masterSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="School Address："
                      prop="fatherInfo.masterSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateEn.fatherInfo.masterSchoolAddress"
                     :rows='5'
                     placeholder="Please enter school address"></Input>
            </FormItem>
            <FormItem label="English Name of School Conferring Doctorate："
                      prop="fatherInfo.phdSchool">
              <Input v-model="formValidateEn.fatherInfo.phdSchool"
                     placeholder="Please enter English name of school conferring doctorate"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="fatherInfo.phdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.fatherInfo.phdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="School Address："
                      prop="fatherInfo.phdSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateEn.fatherInfo.phdSchoolAddress"
                     :rows='5'
                     placeholder="Please enter school address"></Input>
            </FormItem>
            <h4 class='pad-top'>Mother</h4>
            <FormItem label="Name："
                      prop="motherInfo.name">
              <Input v-model="formValidateEn.motherInfo.name"
                     placeholder="Please enter name"
                     clearable></Input>
            </FormItem>
            <FormItem label="Cell Phone Number："
                      prop="motherInfo.phone">
              <Input v-model="formValidateEn.motherInfo.phone"
                     placeholder="Please enter cell phone number"
                     clearable></Input>
            </FormItem>
            <FormItem label="Email："
                      prop="motherInfo.email">
              <Input v-model="formValidateEn.motherInfo.email"
                     placeholder="Please enter email"
                     clearable></Input>
            </FormItem>
            <FormItem label="Date of Graduation："
                      prop="motherInfo.graduationTime">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.motherInfo.graduationTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="Date of Birth："
                      prop="motherInfo.brithday">
              <date-picker-wrapper type="date"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.motherInfo.brithday"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="Place of Birth："
                      prop="motherInfo.brithplace">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.motherInfo.brithplace"
                     placeholder="Please specify city, province, and country"></Input>
            </FormItem>
            <FormItem label="Address："
                      prop="motherInfo.address">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.motherInfo.address"
                     placeholder="Please enter address"></Input>
            </FormItem>
            <FormItem label="Vital Status："
                      prop="motherInfo.vitalStatus">
              <Select v-model="formValidateEn.motherInfo.vitalStatus"
                      placeholder="Please select"
                      @on-change='enMotherInfoVitalStatus'
                      clearable>
                <Option v-for="(item, index) in isVitalEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div v-if='formValidateEn.motherInfo.vitalStatus === "0"'>
              <FormItem label="Time of Death："
                        prop="motherInfo.deathTime">
                <date-picker-wrapper type="date"
                                     :editable='false'
                                     placeholder="Please select"
                                     v-model="formValidateEn.motherInfo.deathTime"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
            </div>
            <FormItem label="Highest Degree Attained："
                      prop="motherInfo.highestDegree">
              <Select v-model="formValidateEn.motherInfo.highestDegree"
                      placeholder="Please select"
                      clearable>
                <Option v-for="item in highestDegreeEnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="Company Name in English："
                      prop="motherInfo.company">
              <Input v-model="formValidateEn.motherInfo.company"
                     placeholder="Please enter company name in English"
                     clearable></Input>
            </FormItem>
            <FormItem label="Job Title："
                      prop="motherInfo.job">
              <Input v-model="formValidateEn.motherInfo.job"
                     placeholder="Please enter job title"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of work at the company："
                      prop="motherInfo.workLength">
              <Input v-model="formValidateEn.motherInfo.workLength"
                     placeholder="Please enter length of work at the company"
                     clearable></Input>
            </FormItem>
            <FormItem label="Mother’s Annual Salary："
                      prop="motherInfo.annualSalary">
              <Input v-model="formValidateEn.motherInfo.annualSalary"
                     placeholder="Required by schools in California, unit - 10,000 yuan"
                     clearable></Input>
            </FormItem>
            <FormItem label="English Name of Junior College/ Technical Secondary School/ High School："
                      prop="motherInfo.highSchool">
              <Input v-model="formValidateEn.motherInfo.highSchool"
                     placeholder="Please enter English name of junior college/ technical secondary School/ high school"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="motherInfo.highSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.motherInfo.highSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="English Name of College/University："
                      prop="motherInfo.ugdSchool">
              <Input v-model="formValidateEn.motherInfo.ugdSchool"
                     placeholder="Please enter English name of college/university"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="motherInfo.ugdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.motherInfo.ugdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="School Address："
                      prop="motherInfo.ugdSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateEn.motherInfo.ugdSchoolAddress"
                     :rows='5'
                     placeholder="Please enter school address"></Input>
            </FormItem>
            <FormItem label="English Name of School Conferring Master's Degree："
                      prop="motherInfo.masterSchool">
              <Input v-model="formValidateEn.motherInfo.masterSchool"
                     placeholder="Please enter English name of school conferring master's degree"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="motherInfo.masterSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.motherInfo.masterSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="School Address："
                      prop="motherInfo.masterSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateEn.motherInfo.masterSchoolAddress"
                     :rows='5'
                     placeholder="Please enter school address"></Input>
            </FormItem>
            <FormItem label="English Name of School Conferring Doctorate："
                      prop="motherInfo.phdSchool">
              <Input v-model="formValidateEn.motherInfo.phdSchool"
                     placeholder="Please enter English name of school conferring doctorate"
                     clearable></Input>
            </FormItem>
            <FormItem label="Length of Study："
                      prop="motherInfo.phdSchoolTime">
              <date-picker-wrapper type="daterange"
                                   :editable='false'
                                   placeholder="Please select"
                                   v-model="formValidateEn.motherInfo.phdSchoolTime"
                                   style="width:100%;"></date-picker-wrapper>
            </FormItem>
            <FormItem label="School Address："
                      prop="motherInfo.phdSchoolAddress">
              <Input type='textarea'
                     v-model="formValidateEn.motherInfo.phdSchoolAddress"
                     :rows='5'
                     placeholder="Please enter school address"></Input>
            </FormItem>
            <h4 class='pad-top'>Additional Information</h4>
            <FormItem label="Parents' Marital Status："
                      prop="maritalStatus">
              <Select v-model="formValidateEn.maritalStatus"
                      placeholder="Please select"
                      @on-change='enMaritalStatus'
                      clearable>
                <Option v-for="item in maritalEnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div v-if='formValidateEn.maritalStatus === "DIVORCED"'>
              <FormItem label="Date of Divorce："
                        prop="divorceDate">
                <date-picker-wrapper type="date"
                                     :editable='false'
                                     placeholder="Please select"
                                     v-model="formValidateEn.divorceDate"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
            </div>
            <FormItem label="Applicant's Legal Guardian："
                      prop="guardian">
              <Select v-model="formValidateEn.guardian"
                      placeholder="Please select"
                      @on-change='enGuardian'
                      clearable>
                <Option v-for="item in guardianEnMap"
                        :value="item[0]"
                        :key="item[0]">{{item[1]}}
                </Option>
              </Select>
              <!-- <Input v-model="formValidateEn.guardian"
                     placeholder="Please enter applicant's legal guardian"
                     clearable></Input> -->
            </FormItem>
            <div v-if='formValidateEn.guardian === "OTHER"'>
              <FormItem label="Other Legal Guardian："
                        prop="otherGuardian">
                <Input v-model="formValidateEn.otherGuardian"
                       placeholder="Please enter other legal guardian"
                       clearable></Input>
              </FormItem>
            </div>
            <FormItem label="Siblings："
                      prop="siblingCount">
              <Select v-model="formValidateEn.siblingCount"
                      placeholder="Please select">
                <Option v-for="(item, index) in brotherEnMap"
                        :value="item[0]"
                        :key="index">{{item[1]}}
                </Option>
              </Select>
            </FormItem>
            <div class="base-form-item-list"
                 v-if='formValidateEn.siblings && formValidateEn.siblings.length > 0'>
              <div class="base-form-item"
                   v-for='(item, index) in formValidateEn.siblings'
                   :key='index'>
                <FormItem label="Relationship with applicant："
                          :prop="`siblings.${index}.relationship`"
                          :rules="[{required: true, message: 'Please enter relationship with applicant'}]">
                  <Input v-model="item.relationship"
                         placeholder="Please enter relationship with applicant"
                         clearable></Input>
                </FormItem>
                <FormItem label="Date of birth："
                          :prop="`siblings.${index}.brithday`"
                          :rules="[{required: true, message: 'Please select'}]">
                  <date-picker-wrapper type="date"
                                       :editable='false'
                                       placeholder="Please select"
                                       v-model="item.brithday"
                                       style="width:100%;"></date-picker-wrapper>
                </FormItem>
                <FormItem label="Level of Education："
                          :prop="`siblings.${index}.degree`"
                          :rules="[{required: true, message: 'Please enter level of education'}]">
                  <Input v-model="item.degree"
                         placeholder="Please enter level of education"></Input>
                </FormItem>
                <FormItem label="Chinese Name of School："
                          :prop="`siblings.${index}.school`"
                          :rules="[{required: true, message: 'Please enter Chinese name of school'}]">
                  <Input v-model="item.school"
                         placeholder="Please enter Chinese name of school"></Input>
                </FormItem>
                <div class='oper-del'>
                  <a href='javascript: void(0)'
                     @click="delEn(item, index)">Delete</a>
                </div>
              </div>
            </div>
            <div class='oper-add'>
              <a href='javascript: void(0)'
                 @click="addEn">Add</a>
            </div>
            <FormItem label="Additional Information："
                      prop="otherInfo">
              <Input type='textarea'
                     :rows='5'
                     v-model="formValidateEn.otherInfo"
                     placeholder="e.g. multiple siblings"></Input>
            </FormItem>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveEn'
                    @click="saveEn">Save</Button>
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEditCn">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import {
  brotherCnMap,
  brotherEnMap,
  guardianCnMap,
  guardianEnMap,
  highestDegreeCnMap,
  highestDegreeEnMap,
  isVitalCnMap,
  isVitalEnMap,
  maritalCnMap,
  maritalEnMap
} from '../constants'
import dayjs from 'dayjs'
import './cv-detail.less'
import DatePickerWrapper from '@/components/date/DatePickerWrapper'

export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: { DatePickerWrapper },
  data () {
    return {
      // 监护人映射
      guardianCnMap,
      guardianEnMap,
      // 是否健在映射
      isVitalCnMap,
      isVitalEnMap,
      // 最高学历映射
      highestDegreeCnMap,
      highestDegreeEnMap,
      // 父母婚姻状况映射
      maritalCnMap,
      maritalEnMap,
      // 是否有兄弟姐妹映射
      brotherCnMap,
      brotherEnMap,
      // 家庭信息详情
      familyDetailCn: {},
      familyDetailEn: {},
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // Cn表单
      formValidateCn: {
        // 父亲
        fatherInfo: {
          name: '',
          phone: '',
          email: '',
          graduationTime: '',
          brithday: '',
          brithplace: '',
          address: '',
          vitalStatus: '',
          deathTime: '',
          highestDegree: '',
          company: '',
          job: '',
          workLength: '',
          annualSalary: '',
          highSchool: '',
          highSchoolTime: ['', ''],
          highSchoolStartTime: '',
          highSchoolEndTime: '',
          ugdSchool: '',
          ugdSchoolTime: ['', ''],
          ugdSchoolStartTime: '',
          ugdSchoolEndTime: '',
          masterSchool: '',
          masterSchoolTime: ['', ''],
          masterSchoolStartTime: '',
          masterSchoolEndTime: '',
          masterSchoolAddress: '',
          phdSchool: '',
          phdSchoolStartTime: '',
          phdSchoolEndTime: '',
          phdSchoolAddress: ''
        },
        // 母亲
        motherInfo: {
          name: '',
          phone: '',
          email: '',
          graduationTime: '',
          brithday: '',
          brithplace: '',
          address: '',
          vitalStatus: '',
          deathTime: '',
          highestDegree: '',
          company: '',
          job: '',
          workLength: '',
          annualSalary: '',
          highSchool: '',
          highSchoolTime: ['', ''],
          highSchoolStartTime: '',
          highSchoolEndTime: '',
          ugdSchool: '',
          ugdSchoolTime: ['', ''],
          ugdSchoolStartTime: '',
          ugdSchoolEndTime: '',
          masterSchool: '',
          masterSchoolTime: ['', ''],
          masterSchoolStartTime: '',
          masterSchoolEndTime: '',
          masterSchoolAddress: '',
          phdSchool: '',
          phdSchoolTime: ['', ''],
          phdSchoolStartTime: '',
          phdSchoolEndTime: '',
          phdSchoolAddress: ''
        },
        // 其他
        maritalStatus: '',
        divorceDate: '',
        guardian: '',
        otherGuardian: '',
        siblingCount: '',
        siblings: [
          //   {
          //   relationship: '',
          //   brithday: '',
          //   degree: '',
          //   school: ''
          // }
        ],
        otherInfo: ''
      },
      ruleValidateCn: {},
      // En表单
      formValidateEn: {},
      ruleValidateEn: {},
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getFamilyDetailCn()
      }
      if (this.lang === 'en') {
        this.getFamilyDetailEn()
      }
    })
  },
  methods: {
    // 获取家庭信息-cn
    getFamilyDetailCn () {
      cvService.cvFamilyDetailCn().then(res => {
        let data = res.data.model
        let temp = res.data.model
        if (data) {
          data.siblingCount = (temp.siblingCount || String(temp.siblingCount) === '0') ? String(temp.siblingCount) : ''
          if (data.fatherInfo) {
            data.fatherInfo.vitalStatus = (temp.fatherInfo.vitalStatus || String(temp.fatherInfo.vitalStatus) === '0') ? String(temp.fatherInfo.vitalStatus) : ''
            if (data.fatherInfo.highSchoolTime && data.fatherInfo.highSchoolTime.length > 0 && data.fatherInfo.highSchoolTime[0]) {
              data.fatherInfo.highSchoolTime[0] = dayjs(temp.fatherInfo.highSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.highSchoolTime[1] = dayjs(temp.fatherInfo.highSchoolTime[1]).format('YYYY-MM-DD')
            }
            if (data.fatherInfo.ugdSchoolTime && data.fatherInfo.ugdSchoolTime.length > 0 && data.fatherInfo.ugdSchoolTime[0]) {
              data.fatherInfo.ugdSchoolTime[0] = dayjs(temp.fatherInfo.ugdSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.ugdSchoolTime[1] = dayjs(temp.fatherInfo.ugdSchoolTime[1]).format('YYYY-MM-DD')
            }
            if (data.fatherInfo.masterSchoolTime && data.fatherInfo.masterSchoolTime.length > 0 && data.fatherInfo.masterSchoolTime[0]) {
              data.fatherInfo.masterSchoolTime[0] = dayjs(temp.fatherInfo.masterSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.masterSchoolTime[1] = dayjs(temp.fatherInfo.masterSchoolTime[1]).format('YYYY-MM-DD')
            }
            if (data.fatherInfo.phdSchoolTime && data.fatherInfo.phdSchoolTime.length > 0 && data.fatherInfo.phdSchoolTime[0]) {
              data.fatherInfo.phdSchoolTime[0] = dayjs(temp.fatherInfo.phdSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.phdSchoolTime[1] = dayjs(temp.fatherInfo.phdSchoolTime[1]).format('YYYY-MM-DD')
            }
          }
          if (data.motherInfo) {
            data.motherInfo.vitalStatus = (temp.motherInfo.vitalStatus || String(temp.motherInfo.vitalStatus) === '0') ? String(temp.motherInfo.vitalStatus) : ''
            if (data.motherInfo.highSchoolTime && data.motherInfo.highSchoolTime.length > 0 && data.motherInfo.highSchoolTime[0]) {
              data.motherInfo.highSchoolTime[0] = dayjs(temp.motherInfo.highSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.highSchoolTime[1] = dayjs(temp.motherInfo.highSchoolTime[1]).format('YYYY-MM-DD')
            }
            if (data.motherInfo.ugdSchoolTime && data.motherInfo.ugdSchoolTime.length > 0 && data.motherInfo.ugdSchoolTime[0]) {
              data.motherInfo.ugdSchoolTime[0] = dayjs(temp.motherInfo.ugdSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.ugdSchoolTime[1] = dayjs(temp.motherInfo.ugdSchoolTime[1]).format('YYYY-MM-DD')
            }
            if (data.motherInfo.masterSchoolTime && data.motherInfo.masterSchoolTime.length > 0 && data.motherInfo.masterSchoolTime[0]) {
              data.motherInfo.masterSchoolTime[0] = dayjs(temp.motherInfo.masterSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.masterSchoolTime[1] = dayjs(temp.motherInfo.masterSchoolTime[1]).format('YYYY-MM-DD')
            }
            if (data.motherInfo.phdSchoolTime && data.motherInfo.phdSchoolTime.length > 0 && data.motherInfo.phdSchoolTime[0]) {
              data.motherInfo.phdSchoolTime[0] = dayjs(temp.motherInfo.phdSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.phdSchoolTime[1] = dayjs(temp.motherInfo.phdSchoolTime[1]).format('YYYY-MM-DD')
            }
          }
          this.familyDetailCn = data
          this.formValidateCn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取家庭信息-en
    getFamilyDetailEn () {
      cvService.cvFamilyDetailEn().then(res => {
        let data = res.data.model
        let temp = res.data.model
        if (data) {
          data.siblingCount = (temp.siblingCount || String(temp.siblingCount) === '0') ? String(temp.siblingCount) : ''
          if (data.fatherInfo) {
            data.fatherInfo.vitalStatus = (temp.fatherInfo.vitalStatus || String(temp.fatherInfo.vitalStatus) === '0') ? String(temp.fatherInfo.vitalStatus) : ''
            if (data.fatherInfo.highSchoolTime && data.fatherInfo.highSchoolTime.length > 0 && data.fatherInfo.highSchoolTime[0]) {
              data.fatherInfo.highSchoolTime[0] = dayjs(temp.fatherInfo.highSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.highSchoolTime[1] = dayjs(temp.fatherInfo.highSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.fatherInfo.highSchoolTime = ['', '']
            }
            if (data.fatherInfo.ugdSchoolTime && data.fatherInfo.ugdSchoolTime.length > 0 && data.fatherInfo.ugdSchoolTime[0]) {
              data.fatherInfo.ugdSchoolTime[0] = dayjs(temp.fatherInfo.ugdSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.ugdSchoolTime[1] = dayjs(temp.fatherInfo.ugdSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.fatherInfo.ugdSchoolTime = ['', '']
            }
            if (data.fatherInfo.masterSchoolTime && data.fatherInfo.masterSchoolTime.length > 0 && data.fatherInfo.masterSchoolTime[0]) {
              data.fatherInfo.masterSchoolTime[0] = dayjs(temp.fatherInfo.masterSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.masterSchoolTime[1] = dayjs(temp.fatherInfo.masterSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.fatherInfo.masterSchoolTime = ['', '']
            }
            if (data.fatherInfo.phdSchoolTime && data.fatherInfo.phdSchoolTime.length > 0 && data.fatherInfo.phdSchoolTime[0]) {
              data.fatherInfo.phdSchoolTime[0] = dayjs(temp.fatherInfo.phdSchoolTime[0]).format('YYYY-MM-DD')
              data.fatherInfo.phdSchoolTime[1] = dayjs(temp.fatherInfo.phdSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.fatherInfo.phdSchoolTime = ['', '']
            }
          }
          if (data.motherInfo) {
            data.motherInfo.vitalStatus = (temp.motherInfo.vitalStatus || String(temp.motherInfo.vitalStatus) === '0') ? String(temp.motherInfo.vitalStatus) : ''
            if (data.motherInfo.highSchoolTime && data.motherInfo.highSchoolTime.length > 0 && data.motherInfo.highSchoolTime[0]) {
              data.motherInfo.highSchoolTime[0] = dayjs(temp.motherInfo.highSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.highSchoolTime[1] = dayjs(temp.motherInfo.highSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.motherInfo.highSchoolTime = ['', '']
            }
            if (data.motherInfo.ugdSchoolTime && data.motherInfo.ugdSchoolTime.length > 0 && data.motherInfo.ugdSchoolTime[0]) {
              data.motherInfo.ugdSchoolTime[0] = dayjs(temp.motherInfo.ugdSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.ugdSchoolTime[1] = dayjs(temp.motherInfo.ugdSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.motherInfo.ugdSchoolTime = ['', '']
            }
            if (data.motherInfo.masterSchoolTime && data.motherInfo.masterSchoolTime.length > 0 && data.motherInfo.masterSchoolTime[0]) {
              data.motherInfo.masterSchoolTime[0] = dayjs(temp.motherInfo.masterSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.masterSchoolTime[1] = dayjs(temp.motherInfo.masterSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.motherInfo.masterSchoolTime = ['', '']
            }
            if (data.motherInfo.phdSchoolTime && data.motherInfo.phdSchoolTime.length > 0 && data.motherInfo.phdSchoolTime[0]) {
              data.motherInfo.phdSchoolTime[0] = dayjs(temp.motherInfo.phdSchoolTime[0]).format('YYYY-MM-DD')
              data.motherInfo.phdSchoolTime[1] = dayjs(temp.motherInfo.phdSchoolTime[1]).format('YYYY-MM-DD')
            } else {
              data.motherInfo.phdSchoolTime = ['', '']
            }
          }
          this.familyDetailEn = data
          this.formValidateEn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEditCn () {
      this.isEditCn = !this.isEditCn
      this.getFamilyDetailCn()
    },
    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getFamilyDetailEn()
    },
    // 删除
    delCn (item, index) {
      this.formValidateCn.siblings.splice(index, 1)
    },
    // Delete
    delEn (item, index) {
      this.formValidateEn.siblings.splice(index, 1)
    },
    // 添加
    addCn () {
      this.formValidateCn.siblings.push(
        {
          relationship: '',
          brithday: '',
          degree: '',
          school: ''
        }
      )
    },
    // Add
    addEn () {
      this.formValidateEn.siblings.push(
        {
          relationship: '',
          brithday: '',
          degree: '',
          school: ''
        }
      )
    },
    // 父亲信息-cn-是否健在-onchange事件
    cnFatherInfoVitalStatus (val) {
      if (val !== '0') {
        this.formValidateCn.fatherInfo.deathTime = ''
      }
    },
    // 母亲信息-cn-是否健在-onchange事件
    cnMotherInfoVitalStatus (val) {
      if (val !== '0') {
        this.formValidateCn.motherInfo.deathTime = ''
      }
    },
    // 父亲信息-en-是否健在-onchange事件
    enFatherInfoVitalStatus (val) {
      if (val !== '0') {
        this.formValidateEn.fatherInfo.deathTime = ''
      }
    },
    // 母亲信息-en-是否健在-onchange事件
    enMotherInfoVitalStatus (val) {
      if (val !== '0') {
        this.formValidateEn.motherInfo.deathTime = ''
      }
    },
    // cn-你的法定监护人-onChange事件
    cnGuardian (val) {
      if (val !== 'OTHER') {
        this.formValidateCn.otherGuardian = ''
      }
    },
    // en-你的法定监护人-onChange事件
    enGuardian (val) {
      if (val !== 'OTHER') {
        this.formValidateEn.otherGuardian = ''
      }
    },
    // cn-父母婚姻状况-onChange事件
    cnMaritalStatus (val) {
      if (val !== 'DIVORCED') {
        this.formValidateCn.divorceDate = ''
      }
    },
    // en-父母婚姻状况-onChange事件
    enMaritalStatus (val) {
      if (val !== 'DIVORCED') {
        this.formValidateEn.divorceDate = ''
      }
    },
    // 保存
    saveCn () {
      this.$refs.formValidateCn.validate((valid) => {
        if (valid) {
          this.hasSaveCn = true
          // 调用接口
          cvService.cvSaveFamilyCn(this.formValidateCn).then(res => {
            this.hasSaveCn = false
            this.isEditCn = false
            this.$ugd_message('保存成功', 'success')
            this.getFamilyDetailCn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveCn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    // Save
    saveEn () {
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          this.hasSaveEn = true
          // 调用接口
          cvService.cvSaveFamilyEn(this.formValidateEn).then(res => {
            this.hasSaveEn = false
            this.isEditEn = false
            this.$ugd_message('Save Success', 'success')
            this.getFamilyDetailEn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveEn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
